<div class="default-cards templates-cards" *ngIf="dataSource.connect() | async as data">
    <div class="cards-card" *ngFor="let item of data" (click)="onSelectTemplate(item)">
        <div class="card-item card-image">
            <div class="item-image">
                <a
                    *ngIf="item.scheme?.url && item.scheme?.preview"
                    [href]="item.scheme.url"
                    target="_blank"
                    (mouseenter)="onImageHover($event, item)"
                    (mousemove)="onImageHover($event, item)"
                    (mouseleave)="onImageHover($event, item)"
                >
                    <img [src]="item.scheme.preview" />
                </a>
            </div>
        </div>
        <div class="card-item">
            <div class="item-description">
                {{ 'OVERVIEW.TABLE.COLUMN.TEMPLATES.DESCRIPTION' | translate }}
            </div>
            {{ item.description }}
        </div>
        <div class="card-item">
            <div class="item-description">
                {{ 'OVERVIEW.TABLE.COLUMN.TEMPLATES.TITLE' | translate }}
            </div>
            {{ item.customerPurchaseNumber }}
        </div>
        <div class="card-item card-toolbar" *ngIf="isAdmin">
            <button mat-icon-button color="primary" (click)="onEditTemplate(item); $event.stopPropagation()">
                <mat-icon class="material-icons-outlined">edit</mat-icon>
            </button>
            <button mat-icon-button color="primary" (click)="onDeleteTemplate(item); $event.stopPropagation()">
                <mat-icon>delete</mat-icon>
            </button>
        </div>
    </div>
</div>

<div class="default-paginator" *ngIf="customPaginator">
    <button mat-icon-button (click)="goToFirstPage()" [disabled]="customPaginator.pageIndex === 0">
        <mat-icon>first_page</mat-icon>
    </button>
    <button mat-icon-button (click)="goToPreviousPage()" [disabled]="customPaginator.pageIndex === 0">
        <mat-icon>chevron_left</mat-icon>
    </button>
    <div class="paginator-pages">{{ customPaginator.pageIndex + 1 }}/{{ getTotalPages() }}</div>
    <button mat-icon-button (click)="goToNextPage()" [disabled]="customPaginator.pageIndex + 1 >= getTotalPages()">
        <mat-icon>chevron_right</mat-icon>
    </button>
    <button mat-icon-button (click)="goToLastPage()" [disabled]="customPaginator.pageIndex + 1 >= getTotalPages()">
        <mat-icon>last_page</mat-icon>
    </button>
</div>

<mat-paginator
    [length]="dataSource?.totalCount$ | async"
    [pageSize]="25"
    [pageSizeOptions]="[]"
    showFirstLastButtons
    hidePageSize
    #customPaginator
>
</mat-paginator>

<div *ngIf="!dataSource?.hasData()" fxLayout="row" fxLayoutAlign="center center">
    <p data-at-no-results>{{ 'COMMON.NO_RESULTS' | translate }}</p>
</div>
